import { createAssistantTitle } from "../api-client/assistant-title-api.js";
import {
    answerAgentSession,
    cancelAgentSession,
    createAgentSession,
    getAgentSession as getRemoteAgentSession,
    listAgentSessions
} from "../api-client/agent-session-api.js";
import { getFaAgentVerifyStatus, postFaAgentVerify, postGenerate, postValidate } from "../api-client/generation-api.js";
import { getClerkAccessToken } from "../api-client/clerk-browser.js";
import { buildRawFlowIndex } from "../generation/index.js";

export function bindGenerationApiRuntime(deps = {}) {
    const {
        bindGenerationClient = null,
        getAccessToken = getClerkAccessToken,
        info = () => {},
        warn = () => {}
    } = deps;
    if (typeof bindGenerationClient !== "function") {
        warn("[phase4] window.__bindGenerationClient not present; API path disabled");
        return false;
    }
    bindGenerationClient({
        postGenerate,
        postValidate,
        postFaAgentVerify,
        getFaAgentVerifyStatus,
        getAccessToken
    });
    info("[phase4] /api/generate + /api/validate + /api/fa-agent/verify client bound");
    return true;
}

export function bindRawFlowIndexRuntime(deps = {}) {
    const {
        bindRawFlowIndexBuilder = null,
        warn = () => {}
    } = deps;
    if (typeof bindRawFlowIndexBuilder !== "function") {
        warn("[phase4] window.__bindRawFlowIndexBuilder not present; raw flow index helper disabled");
        return false;
    }
    bindRawFlowIndexBuilder(buildRawFlowIndex);
    return true;
}

export function bindAgentSessionApiRuntime(deps = {}) {
    const {
        bindAgentSessionClient = null,
        getAccessToken = getClerkAccessToken,
        restoreAgentSessionFromStorage = null,
        info = () => {},
        warn = () => {}
    } = deps;
    if (typeof bindAgentSessionClient !== "function") {
        warn("[phase4] window.__bindAgentSessionClient not present; agent session API path disabled");
        return false;
    }
    bindAgentSessionClient({
        createSession: createAgentSession,
        getSession: getRemoteAgentSession,
        answerSession: answerAgentSession,
        cancelSession: cancelAgentSession,
        listSessions: listAgentSessions,
        getAccessToken
    });
    info("[phase4] /api/agent-sessions client bound");
    Promise.resolve(restoreAgentSessionFromStorage?.())
        .catch((error) => warn("[phase4] agent session restore after bind failed", error));
    return true;
}

export function bindAssistantTitleApiRuntime(deps = {}) {
    const {
        bindAssistantTitleClient = null,
        info = () => {},
        warn = () => {}
    } = deps;
    if (typeof bindAssistantTitleClient !== "function") {
        warn("[phase4] window.__bindAssistantTitleClient not present; assistant title API path disabled");
        return false;
    }
    bindAssistantTitleClient({
        createAssistantTitle
    });
    info("[phase4] /api/assistant/title client bound");
    return true;
}
